import React, { memo } from 'react'

// bootstrap
import {
    OverlayTrigger,
} from 'react-bootstrap'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// tooltips
import { renderTooltipAutoApplyInfo } from '../../../includes/tooltips/Coupons__Tooltips'

// date picker
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';

// day picker moment
import {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';

import moment from 'moment';

// react select
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline';
import AppFormikInputFieldCheckbox from 'utlis/helpers/forms/AppFormikInputFieldCheckbox';

const animatedComponents = makeAnimated();

function FormCoupons__Details(props) {
    const { handleDateChange, formik, categoriesList, handleCategoryChange, brandsList, handleBrandChange } = props

    const FORMAT = "YYYY-MM-DD"

    // disabling key press
    const handleKeyDown = ev => {
        ev.preventDefault()
        return false
    }

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Coupon Code"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Coupon Code"} // placeholder for the input
                formikFieldName={"couponCode"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Discount Type"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"couponDiscountType"} // important: formik value name for the input
            >
                <option disabled value="">Select Discount Type</option>
                <option value="percent">Percent</option>
                <option value="value">Value</option>
            </AppFormikSelectInline>

            {/* if discount type is percent */}
            {
                (props?.formik?.values?.couponDiscountType === "percent") && (
                    // form field
                    <AppFormikInputInline
                        formik={formik} // formik object
                        stFormClass={"ps-3 st-form-with-label-left no-arrows d-flex flex-wrap align-items-center"} // class name for main wrapper
                        labelName={"Percent"} // label name
                        isRequired={false} // is this field is required or not to show the red star sign
                        placeholder={"Percent"} // placeholder for the input
                        formikFieldName={"couponDiscountPercent"} // important: formik value name for the input
                        inputType={"number"}
                    />
                )
            }

            {/* if discount type is value */}
            {
                (props?.formik?.values?.couponDiscountType === "value") && (
                    // form field
                    <AppFormikInputInline
                        formik={formik} // formik object
                        stFormClass={"ps-3 st-form-with-label-left no-arrows d-flex flex-wrap align-items-center"} // class name for main wrapper
                        labelName={"Value"} // label name
                        isRequired={false} // is this field is required or not to show the red star sign
                        placeholder={"Value"} // placeholder for the input
                        formikFieldName={"couponDiscountValue"} // important: formik value name for the input
                        inputType={"number"}
                    />
                )
            }

            {/* form field */}
            <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${(formik.touched.couponExpiryDate && formik.errors.couponExpiryDate) ? "has-msg msg-error" : ""}`}>
                <label>
                    Expiry Date
                    <span className="required">*</span>
                </label>
                <div className="media-body st-form-input-container">
                    <DayPickerInput
                        onDayChange={handleDateChange}
                        value={formik.values.couponExpiryDate}
                        inputProps={{
                            className: 'form-control',
                            onKeyDown: handleKeyDown
                        }}
                        classNames={{ container: 'date-picker-container' }}
                        dayPickerProps={{
                            todayButton: 'Today',
                            disabledDays: { before: moment().add(1, "days").toDate() }
                        }}
                        formatDate={formatDate}
                        format={FORMAT}
                        parseDate={parseDate}
                        placeholder={"YYYY-MM-DD"}
                        disabledDays={{ daysOfWeek: [0] }}

                    // showOverlay={true}
                    // hideOnDayClick={false}
                    // keepFocus={true}
                    />

                    <input
                        type="text"
                        className="form-control d-none"
                        placeholder="Expiry Date"
                        id="couponExpiryDate"
                        {...formik.getFieldProps('couponExpiryDate')} />
                    {
                        /* form message */
                        (formik.touched.couponExpiryDate && formik.errors.couponExpiryDate) && (
                            <div className="st-form-msg position-absolute">
                                <p className="st-fs-12">{formik.errors.couponExpiryDate}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* form field */}
            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${(formik.touched.couponCategories && formik.errors.couponCategories) ? "has-msg msg-error" : ""}`}>
                <label>
                    Category
                    {/* <span className="required">*</span> */}
                </label>
                <div className="media-body st-form-input-container">
                    {/* category selector */}
                    <Select
                        isMulti
                        name="colors"
                        options={categoriesList}
                        className="react-select-container-custom"
                        classNamePrefix="select"
                        hideSelectedOptions
                        components={animatedComponents}
                        onChange={handleCategoryChange}
                    />

                    <input
                        type="number"
                        className="form-control d-none"
                        placeholder="Category"
                        id="couponCategories"
                        {...formik.getFieldProps('couponCategories')} />
                    {
                        /* form message */
                        (formik.touched.couponCategories && formik.errors.couponCategories) && (
                            <div className="st-form-msg position-absolute">
                                <p className="st-fs-12">{formik.errors.couponCategories}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* form field */}
            <div className={`st-form st-form-with-label-left no-arrows d-flex flex-wrap align-items-center ${(formik.touched.couponBrands && formik.errors.couponBrands) ? "has-msg msg-error" : ""}`}>
                <label>
                    Brand
                    {/* <span className="required">*</span> */}
                </label>
                <div className="media-body st-form-input-container">
                    {/* brand selector */}
                    <Select
                        isMulti
                        name="colors"
                        options={brandsList}
                        className="react-select-container-custom"
                        classNamePrefix="select"
                        hideSelectedOptions
                        components={animatedComponents}
                        onChange={handleBrandChange}
                    />

                    <input
                        type="number"
                        className="form-control d-none"
                        placeholder="Brand"
                        id="couponBrands"
                        {...formik.getFieldProps('couponBrands')} />
                    {
                        /* form message */
                        (formik.touched.couponBrands && formik.errors.couponBrands) && (
                            <div className="st-form-msg position-absolute">
                                <p className="st-fs-12">{formik.errors.couponBrands}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex no-arrows flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Minimum Order Amount"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"Minimum Order Amount"} // placeholder for the input
                formikFieldName={"couponMinOrderAmount"} // important: formik value name for the input
                inputType={"number"}
            />

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Status"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                formikFieldName={"couponStatus"} // important: formik value name for the input
            >
                <option disabled value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </AppFormikSelectInline>

            {/* form field */}
            <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${(formik.touched.couponAutoApply && formik.errors.couponAutoApply) ? "has-msg msg-error" : ""}`}>
                <label className="d-flex justify-content-end">
                    Auto Apply
                    <OverlayTrigger
                        placement={"top"}
                        overlay={renderTooltipAutoApplyInfo}
                    >
                        <span className="info-icon cursor-pointer st-text-primary ms-2">
                            <FeatherIcon
                                icon="info"
                                size="15"
                                className="icon" />
                        </span>
                    </OverlayTrigger>
                </label>
                <div className="media-body st-form-input-container" style={{ textAlign: 'left' }}>
                    <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer position-relative" style={{ top: 3 }}>
                        <input
                            type="checkbox"
                            className="d-none"
                            id="couponAutoApply"
                            checked={formik.values.couponAutoApply}
                            {...formik.getFieldProps('couponAutoApply')} />
                        <span className="box d-flex align-items-center justify-content-center border">
                            <FeatherIcon
                                icon="check"
                                size="15"
                                className="icon position-relative" />
                        </span>
                    </label>

                    {
                        /* form message */
                        (formik.touched.couponAutoApply && formik.errors.couponAutoApply) && (
                            <div className="st-form-msg position-absolute">
                                <p className="st-fs-12">{formik.errors.couponAutoApply}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* form field */}
            <AppFormikInputFieldCheckbox
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Free Shipping"} // label name
                formikFieldName={"couponFreeShiping"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputFieldCheckbox
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Single Use"} // label name
                formikFieldName={"couponSingleUse"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputFieldCheckbox
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Single Use Per User"} // label name
                formikFieldName={"couponSingleUsePerUser"} // important: formik value name for the input
            />

        </React.Fragment>
    )
}

export default memo(FormCoupons__Details)